function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(-8.000000, -7.000000)",
  fill: "#C0C0C0"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path-2",
  points: "8.1861131 7.30901288 14.4137437 7.30901288 20.4266285 26.8369099 26.2247674 7.30901288 32.452398 7.30901288 38.2505369 26.8369099 43.8339298 7.30901288 50.0615605 7.30901288 41.0422334 33.7038627 34.8146027 33.7038627 29.2312097 14.8197425 23.218325 33.7038627 17.2054402 33.7038627"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.7473157,43.796465 L39.1095204,39.2900272 C39.1095204,39.2900272 37.3915533,38.2170658 36.103078,37.573289 C34.8146027,36.9295121 32.705156,35.9309635 29.8754474,35.8565508 C21.7151038,35.6419585 18.2791696,40.5775811 18.2791696,44.2256494 C18.2791696,45.3218859 18.7966332,48.1286184 20.6413744,49.375864 C22.184093,50.4189096 24.5068003,51.092603 26.869005,51.7363798 C29.2312097,52.3801567 33.5261274,53.0239335 33.5261274,56.0282246 C33.5261274,58.6033326 30.519685,58.8179265 29.2312097,58.8179249 C27.9427344,58.8179233 24.9362921,57.9595544 23.218325,57.101186 C21.5003579,56.2428176 19.9971367,54.955264 19.9971367,54.955264 L17.2054402,59.2471095 C17.2054402,59.2471095 21.9298497,63.7535465 29.0164639,63.7535456 C36.103078,63.7535447 39.5390122,60.3200704 39.5390122,56.0282253 C39.5390122,51.7363803 37.6062992,49.8050487 34.385111,48.3029027 C31.1639227,46.8007567 24.7215462,46.15698 24.7215462,43.5818726 C24.7215462,41.0067652 28.3722262,41.0067655 29.0164639,41.0067654 C29.6607015,41.0067653 31.8081603,41.2213576 33.3113815,41.8651344 C34.8146027,42.5089112 36.7473157,43.796465 36.7473157,43.796465 Z",
  id: "Path-3"
})));

function SvgWsNoBorderGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "43px",
    height: "57px",
    viewBox: "0 0 43 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWsNoBorderGrey);
export default __webpack_public_path__ + "static/media/ws-no_border_grey.a1625a7e.svg";
export { ForwardRef as ReactComponent };